// extracted by mini-css-extract-plugin
module.exports = {"homeArticles":"style_homeArticles__JjTKJ","btnList":"style_btnList__c1AIW","articleGridList":"style_articleGridList__701Pj","articleGroup":"style_articleGroup__fTcia"};